import { withTranslation, WithTranslation } from 'react-i18next';
import React from 'react';
import TextField from '../../../form/inputField';
import PopoverContainer from '../../../popover/popover';
import { OrganizationStep1FormResultKeys } from './organizationStep1FormModel';
import { IAccountModel } from '../../../../helpers/models/accountModel';
import {
    FORM_BUSINESS_NUMBER_MAX_LENGTH,
    FORM_GST_MAX_LENGTH,
    FORM_RT_MAX_LENGTH,
} from '../../utils/formValidation';

export interface IOrganizationStep1BusinessInformationsProps extends WithTranslation {
    readonly?: boolean;
    account: IAccountModel;
}

const OrganizationStep1BusinessInformations = (
    props: IOrganizationStep1BusinessInformationsProps
) => {
    const { t, readonly, account } = props;
    return (
        <>
            <h2 className="header-3 header-3--purple registration_form_header">
                {t('form_organization_step_1_business_title')}
            </h2>
            <div className="registration-column-container">
                <TextField
                    fieldContainerClassName="registration-field registration-column-item"
                    fieldName={OrganizationStep1FormResultKeys.ENTERPRISE_NUMBER}
                    fieldTitle="form_organization_step_1_enterprise_number"
                    fieldDisabled={readonly}
                    fieldDisabledPopover={readonly}
                    fieldRequired
                    fieldWeight={12}
                    fieldHiddenLabel="form_organization_step_1_business_title"
                    fieldTooltip={
                        <PopoverContainer
                            icon
                            className={'field-tooltip-icon'}
                            prefix={t('form_organization_step_1_enterprise_number')}
                        >
                            <>
                                <p className="body-medium">
                                    {t('form_organization_step_1_enterprise_number_popover_format')}
                                </p>
                                <p className="body-medium">
                                    {t(
                                        'form_organization_step_1_enterprise_number_popover_proprietor'
                                    )}
                                </p>
                                <p className="body-medium">
                                    {t(
                                        'form_organization_step_1_enterprise_number_popover_more_info_tel'
                                    )}
                                </p>
                            </>
                        </PopoverContainer>
                    }
                    type="text"
                    defaultValue={account.organization?.businessNumber ?? ''}
                    maxLength={FORM_BUSINESS_NUMBER_MAX_LENGTH}
                />
                <TextField
                    fieldContainerClassName="registration-field registration-column-item"
                    fieldName={OrganizationStep1FormResultKeys.TPS}
                    fieldTitle="form_organization_step_1_enterprise_tps"
                    fieldOptionalText="form_organization_step_1_enterprise_tps_optional"
                    fieldDisabled={readonly}
                    fieldWeight={13}
                    fieldHiddenLabel="form_organization_step_1_business_title"
                    type="text"
                    defaultValue={account.organization?.gstHst ?? ''}
                    maxLength={FORM_GST_MAX_LENGTH}
                />
                <TextField
                    fieldContainerClassName="registration-field registration-column-item"
                    fieldName={OrganizationStep1FormResultKeys.RT}
                    fieldTitle="form_organization_step_1_enterprise_rt"
                    fieldOptionalText="form_organization_step_1_enterprise_rt_optional"
                    fieldDisabled={readonly}
                    fieldWeight={14}
                    fieldHiddenLabel="form_organization_step_1_business_title"
                    type="text"
                    defaultValue={account.organization?.rt ?? ''}
                    maxLength={FORM_RT_MAX_LENGTH}
                />
            </div>
        </>
    );
};

export default withTranslation()(OrganizationStep1BusinessInformations);
